import { ConsumerUnit } from 'entities/ConsumerUnit';

/**
 * Usina conectada = ligada a uma conta de monitoramento em Integrações. Fonte
 * única da barra superior, de Primeiros passos e de Integrações (nov/2026, pedido
 * do Bruno): a barra contava toda planta cadastrada e Primeiros passos dava o
 * inversor por concluído com qualquer conta salva, enquanto Integrações dizia
 * "Nenhuma usina conectada" para a mesma conta.
 */
export const connectedPlants = (unit: Pick<ConsumerUnit, 'plantList'>) =>
  (unit.plantList ?? []).filter(
    (plant) => !!plant.monitoringSystemUser?.id && !!plant.identifier
  );

export const connectedPlantCount = (
  units: Pick<ConsumerUnit, 'plantList'>[]
): number =>
  units.reduce((sum, unit) => sum + connectedPlants(unit).length, 0);
